import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-md rounded-3xl border border-border bg-card p-8 text-center shadow-sm">
        <XCircle size={48} className="mx-auto text-muted-foreground" />
        <h1 className="mt-4 font-serif text-2xl font-bold">Checkout canceled</h1>
        <p className="mt-2 text-sm text-muted-foreground">No charge was made. Your listing was not changed.</p>
        <Link to="/sponsor" className="mt-6 inline-block rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground">Back to packages</Link>
      </div>
    </div>
  );
}
